import { InvitacionService } from './src/services/invitaciones.services';
export const invitacionService = new InvitacionService();
export default invitacionService;
